var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1638 16.0653C30.1638 23.8879 23.8225 30.2292 15.9999 30.2292C8.17725 30.2292 1.83594 23.8879 1.83594 16.0653C1.83594 8.24268 8.17725 1.90137 15.9999 1.90137C23.8225 1.90137 30.1638 8.24268 30.1638 16.0653Z",
    fill: "#65AA20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5123 22.9513C14.0682 22.9513 13.6217 22.8107 13.2454 22.5233L7.36579 16.5435C6.45795 15.8505 6.28961 14.5601 6.98995 13.6616C7.69008 12.7632 8.99378 12.5966 9.90162 13.2896L14.2605 18.1086L21.4332 10.2514C22.2018 9.40943 23.5144 9.34356 24.3653 10.1046C25.2159 10.8651 25.2825 12.1646 24.5136 13.0065L16.0535 22.274C15.6455 22.7209 15.0809 22.9513 14.5123 22.9513Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.160c6db212c4e1e3d6468887fae66877.svg";
export { ForwardRef as ReactComponent };